export default "__VITE_ASSET__BA7g6P9m__"